export { default as academiesLocaleEn } from './localeEn';
export { default as academiesLocaleEs } from './localeEs';
export { default as academiesLocalePt } from './localePt';
